__webpack_require__.p = "/apps/chrome/js/";